import { MenuItem, TextField } from "@mui/material";
import { useState } from "react";
import FilterBar from "../../components/enterprise/FilterBar";
import HeatmapPanel from "../../components/enterprise/HeatmapPanel";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { platformMockService } from "../../services/mock/platformMockService";
import { intelligenceTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const HeatmapsPage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  const [metric, setMetric] = useState("risk");
  return (
    <ModuleLayout title={t("platform.pages.heatmaps.title")} subtitle={t("platform.pages.heatmaps.subtitle")} breadcrumbs={[t("platform.nav.intelligence"), t("platform.tabs.heatmaps")]} tabs={intelligenceTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <>
          <FilterBar>
            <TextField select size="small" label={t("platform.tabs.heatmaps")} value={metric} onChange={(event) => setMetric(event.target.value)} sx={{ gridColumn: { md: "span 3" } }}>
              <MenuItem value="traffic">{t("platform.heatmaps.metrics.traffic")}</MenuItem>
              <MenuItem value="alerts">{t("platform.heatmaps.metrics.alerts")}</MenuItem>
              <MenuItem value="theft">{t("platform.heatmaps.metrics.theft")}</MenuItem>
              <MenuItem value="dwell">{t("platform.heatmaps.metrics.dwell")}</MenuItem>
              <MenuItem value="risk">{t("platform.heatmaps.metrics.risk")}</MenuItem>
            </TextField>
          </FilterBar>
          <HeatmapPanel zones={platformMockService.getHeatmapZones()} metric={metric} dataMode={{ mode: "mock" }} />
        </>
      ) : (
        <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledAnalyticsDescription")} />
      )}
    </ModuleLayout>
  );
};

export default HeatmapsPage;
